import React, { Fragment } from 'react';
import useAuthUser from 'src/hooks/useAuthUser';
import PageWrapper from 'src/components/PageWrapper';
import { Route, Switch, Redirect } from 'react-router-dom/';
import CopilotCategorization from 'src/components/Copilot/CopilotCategorization';
import CopilotRecap from 'src/components/Copilot/CopilotRecap';
import PropTypes from 'prop-types';
import theme from 'src/config/theme';
import CopilotPrioritization from 'src/components/Copilot/CopilotPrioritization';
import CopilotGenerateTitle from 'src/components/Copilot/CopilotGenerateTitle';
import AgentWithChat from 'src/components/Copilot/Agent';
import IntentScreen from 'src/components/Copilot/Agent/IntentScreen';
import useIsFeatureFlagEnabled from 'src/hooks/useIsFeatureFlagEnabled';
import featureFlags from 'src/constants/featureFlags';

const Copilot = ({ match }) => {
  const { company } = useAuthUser();
  const isAgentEnabled = useIsFeatureFlagEnabled(featureFlags.MAGIC_AGENT);
  const isGenerateTitleEnabled = useIsFeatureFlagEnabled(featureFlags.COPILOT_GENERATE_TITLE);

  const tabs = [
    { id: 1, path: `${match.url}/prioritization`, name: 'Prioritization' },
    { id: 2, path: `${match.url}/categorization`, name: 'Categorization' },
    { id: 3, path: `${match.url}/recap`, name: 'Recap' },
    ...(isGenerateTitleEnabled ? [{ id: 4, path: `${match.url}/title`, name: 'Title' }] : []),
    ...(isAgentEnabled
      ? [{ id: 5, path: `${match.url}/agent`, name: 'Agent', isNested: true }]
      : [])
  ];

  const pageWrapperProps = {
    title: 'Magic AI',
    tabs,
    padding: 0,
    backgroundColor: theme.colors.common.white
  };

  const redirectPath = `${match.path}/prioritization`;

  return (
    <Switch>
      <Redirect exact from={match.path} to={redirectPath} />
      <Route path={`${match.path}/prioritization`}>
        <PageWrapper {...pageWrapperProps}>
          <CopilotPrioritization companyId={company.id} />
        </PageWrapper>
      </Route>
      <Route path={`${match.path}/categorization`}>
        <PageWrapper {...pageWrapperProps}>
          <CopilotCategorization companyId={company.id} />
        </PageWrapper>
      </Route>
      <Route path={`${match.path}/recap`}>
        <PageWrapper {...pageWrapperProps}>
          <CopilotRecap companyId={company.id} />
        </PageWrapper>
      </Route>
      {isGenerateTitleEnabled && (
        <Route path={`${match.path}/title`}>
          <PageWrapper {...pageWrapperProps}>
            <CopilotGenerateTitle />
          </PageWrapper>
        </Route>
      )}
      {isAgentEnabled && (
        <Fragment>
          <Route path={[`${match.path}/agent`, `${match.path}/agent/settings`]} exact>
            <PageWrapper {...pageWrapperProps}>
              <AgentWithChat appId={company.appId} base={`${match.path}/agent`} />
            </PageWrapper>
          </Route>
          <Route path={`${match.path}/agent/create`} exact component={IntentScreen} />
          <Route path={`${match.path}/agent/update/:intentId`} exact component={IntentScreen} />
        </Fragment>
      )}
    </Switch>
  );
};

Copilot.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
    path: PropTypes.string
  }).isRequired
};

export default Copilot;
